var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
    [
      _c("c-card", {
        staticClass: "cardClassDetailForm",
        attrs: { title: "법규별 규제사항" },
        scopedSlots: _vm._u([
          {
            key: "card-detail",
            fn: function () {
              return _vm._l(_vm.bills, function (item, idx) {
                return _c(
                  "div",
                  { key: idx, staticClass: "col-12 chemLawRegulCheckbox" },
                  [
                    _c("div", { staticClass: "chemLawRegulBillDiv" }, [
                      _vm._v(_vm._s(item.regulationBillName)),
                    ]),
                    _vm._l(item.reguls, function (regul, _idx) {
                      return _c("q-checkbox", {
                        key: _idx,
                        staticClass: "customqcbox",
                        attrs: {
                          disable: "",
                          dense: "",
                          color: "orange-custom",
                          "true-value": "Y",
                          "false-value": "N",
                          label: regul.regulatedItemName,
                        },
                        model: {
                          value: regul.val,
                          callback: function ($$v) {
                            _vm.$set(regul, "val", $$v)
                          },
                          expression: "regul.val",
                        },
                      })
                    }),
                  ],
                  2
                )
              })
            },
            proxy: true,
          },
        ]),
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }